
import React from "react";
import { Table, Card, CardBody, CardHeader, CardTitle } from "reactstrap";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
function OrderRiverHillInvoice({ orderData }) {
  return (
    
    <>
      <Card className="InvoiceBreakUp">
        <CardHeader>
          <CardTitle>INVOICE BREAK UP</CardTitle>
        </CardHeader>
        {orderData !== undefined ? (
              <>
        <CardBody>
          <div className="table-responsive">
            <Table className="table mb-0">
              <tbody>
            
                <tr>
                  <td>Shipping Fee :</td>
                  <td>
                    {orderData?.Currency} {orderData?.ShippingCharge}
                  </td>
                </tr>
                <tr>
                  <td>Discount :</td>
                  <td>
                    -({orderData?.Currency} {orderData?.DiscountTotal})
                  </td>
                </tr>
                <tr>
                  <th className="Border">Grand Total :</th>
                  <th className="Border">AED {orderData?.OrderTotal}</th>
                </tr>
              </tbody>
            </Table>
          </div>
        </CardBody>
        </>
            ) : (<>
              <CardBody>
               <Skeleton count={7} />
               </CardBody>
                </>
              )}
      </Card>
    </>
  );
}
export default OrderRiverHillInvoice;
